import { render, staticRenderFns } from "./SysPortalOrgModal.vue?vue&type=template&id=8b8a5a1e&"
import script from "./SysPortalOrgModal.vue?vue&type=script&lang=js&"
export * from "./SysPortalOrgModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b8a5a1e')) {
      api.createRecord('8b8a5a1e', component.options)
    } else {
      api.reload('8b8a5a1e', component.options)
    }
    module.hot.accept("./SysPortalOrgModal.vue?vue&type=template&id=8b8a5a1e&", function () {
      api.rerender('8b8a5a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portal/modules/SysPortalOrgModal.vue"
export default component.exports